
const baseFont = {
  fontFamily: "'Segoe UI', sans-serif",
  fontSize: "13px",
};
const inputBlock = (state) => {
  const isInvalid = state.selectProps.isInvalid;
  const focused = state.isFocused;
  return {
    ...baseFont,
    height: 40,
    minHeight: 40,
    backgroundColor: isInvalid ? "rgba(255,60,60,0.08)" : "#1b1f26",
    color: "#e8f0ff",
    borderRadius: 10,
    border: `1px solid ${
      isInvalid ? "#ff6b6b" : focused ? "rgba(70,149,230,1)" : "rgba(255,255,255,0.12)"
    }`,
    boxShadow: focused ? "0 0 0 3px rgba(70,149,230,0.15)" : "none",
    outline: "none",
    paddingLeft: 10,
    transition: "border-color .15s ease, box-shadow .15s ease",
    "&:hover": {
      borderColor: isInvalid ? "#ff6b6b" : focused ? "#4695e6" : "rgba(255,255,255,0.18)",
    },
  };
};
export const customSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    ...inputBlock(state),
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: "0 10px",
  }),
  input: (provided) => ({
    ...provided,
    ...baseFont,
    color: "#e8f0ff",
    margin: 0,
  }),
  singleValue: (provided) => ({
    ...provided,
    ...baseFont,
    color: "#e8f0ff",
  }),
  placeholder: (provided) => ({
    ...provided,
    ...baseFont,
    color: "rgba(164, 173, 190, 0.78)",
    fontSize: "11px",
    fontStyle: "italic",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    paddingRight: 8,
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: state.selectProps.menuIsOpen ? "#019dee" : "#888",
    transition: "transform .2s ease, color .15s ease",
    transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : "rotate(0deg)",
    ":hover": { color: "#019dee" },
  }),
  clearIndicator: (provided) => ({
    ...provided,
    color: "#666",
    ":hover": { color: "red", cursor: "pointer" },
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    backgroundColor: "rgba(255,255,255,0.12)",
  }),
  menu: (provided) => ({
    ...provided,
    ...baseFont,
    backgroundColor: "#121418",
    border: "1px solid rgba(255,255,255,0.12)",
    borderRadius: 10,
    overflow: "hidden",
    zIndex: 9999,
  }),
  // portal com z-index alto para não cortar o menu
  menuPortal: (base) => ({
    ...base,
    zIndex: 99999,
  }),
  option: (provided, state) => ({
    ...provided,
    ...baseFont,
    backgroundColor: state.isSelected
      ? "#019dee"
      : state.isFocused
      ? "#222733"
      : "transparent",
    color: "#fff",
    cursor: "pointer",
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "#222733",
    borderRadius: 8,
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    ...baseFont,
    color: "#f5f7ff",
    paddingRight: 4,
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "#f5f7ff",
    ":hover": { backgroundColor: "#ff6b6b", color: "#fff", borderRadius: 8 },
  }),
};
// variante para o select da BANDEIRA (lado esquerdo do telefone)
export const customSelectStylesFlagLeft = {
  ...customSelectStyles,
  control: (provided, state) => ({
    ...customSelectStyles.control(provided, state),
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    borderRight: "none",        // cola ao input
    minWidth: 62,
  }),
  valueContainer: (provided) => ({
    ...customSelectStyles.valueContainer(provided),
    padding: "0 8px",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    paddingRight: 6,
  }),
  indicatorSeparator: () => ({ display: "none" }), // <— esconde a barra
};
